import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class ServiceMerchantFilter extends Component {
    state = {
        merchantList:[],
        merchantValue: null,
        isMerchantLoading: true
    };
    componentDidMount(){
        this._getAllMerchants();

        if(this.props.object_type==='Merchant'){
            var merchantData = [];
            this.props.object_code.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
                this.changeMerchant('merchant', merchantData);
            }
    }
    restMerchantFilter() {
        this.setState({
            merchantValue: [],
        })
    }
    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/filters/service_reports/get-merchants/',{
            headers: {
                Authorization: `${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    isMerchantLoading: false
                })
            }
        });
    }
    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (this.props.object_type != 'Merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        this.props.onSelectMerchant(optionSelected, midArray);
        this.setState({
            merchantValue:optionSelected,
        });

    }
    render() {
        return (
            <ReactMultiSelectCheckboxes name="merchants"
                isMulti
//                 components={{ MenuList }}
                value={this.state.merchantValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeMerchant.bind(this,'')}
                options={this.state.merchantList}
                placeholderButtonLabel="Select [Merchant]"
                isLoading={this.state.isMerchantLoading}
            />
        );

    }
}
export default ServiceMerchantFilter;